import React from 'react';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from 'reactstrap';

type ConfirmProps = {
  isOpen: boolean;
  toggle: () => void;
  yesFn: () => void;
  children: any;
  title: string;
  size?: string;
};

const Confirm: React.FC<ConfirmProps> = ({
  children,
  isOpen,
  toggle,
  title,
  yesFn,
  size = '',
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} size={size}>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>
      <ModalBody>{children}</ModalBody>
      <ModalFooter
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '10px',
        }}
      >
        <Button color="primary" onClick={yesFn}>
          Si
        </Button>
        <Button color="secondary" onClick={toggle}>
          No
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default Confirm;
